import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AppStateSelectors } from '@appState/app-state.selector';
import { Observable } from 'rxjs';
import { FacilityService, TGetCO2FacilityDTO } from '@api';
import {
  LoadFacilityList,
  LoadSelectedFacilityById,
} from '@appState/app.actions';
import { ErrorHandlingService } from '@services';
import { MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-co2-location-dangling',
  templateUrl: './co2-location-dangling.component.html',
  styleUrl: './co2-location-dangling.component.scss',
})
export class Co2LocationDanglingComponent implements OnInit {
  @Select(AppStateSelectors.isLoading)
  public readonly isLoading$: Observable<boolean>;
  @Select(AppStateSelectors.getSelectedFacility())
  public readonly facility$: Observable<TGetCO2FacilityDTO>;

  private _facility;

  constructor(
    private readonly store: Store,
    private readonly facilityService: FacilityService,
    private readonly errorHandlingService: ErrorHandlingService,
    public dialogRef: MatDialogRef<Co2LocationDanglingComponent>
  ) {}

  ngOnInit() {
    this.store.dispatch(new LoadSelectedFacilityById());

    this.facility$.pipe(untilDestroyed(this))
      .subscribe(f => (this._facility = f));
  }

  public onSave(): void {
    this.facilityService.apiFacilityPut({
      co2_facility: {
        ...this._facility,
        facility_latitude: this._facility.facility_longitude,
        facility_longitude: this._facility.facility_latitude,
      }
    }).subscribe({
      next: () => {
        this.dialogRef.close();
        this.store.dispatch(new LoadFacilityList());
      },
      error: err => this.errorHandlingService.showError(err),
    });
  }
}
